import { connect } from 'react-redux';

import { setChannels } from '@store/actions/channels';
import API from '@api';
import App from './App';

const mapStateToProps = state => ({
  nid: state.ux.nid,
});

const mapDispatchToProps = dispatch => ({
  getChannels: nid => {
    return API.getChannels(nid)
      .then(channels => {
        dispatch(setChannels(channels));
        return;
      })
      .catch(error => {
        console.error(error);
      });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
